import PropTypes from 'prop-types';

import { Box, Tooltip } from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

import { formatActionItems } from './utils';

import { ActionButton } from '../Button';
import DropDownMenu from '../DropDownMenu';

const SingleAction = ({
  action: { label, color, onClick, isFullWidth, disabled, tooltip },
}) => {
  const actionButton = (
    <ActionButton
      variant="contained"
      disableElevation
      style={color ? { backgroundColor: color } : {}}
      onClick={() => onClick()}
      fullWidth={isFullWidth}
      disabled={disabled}
    >
      {label}
    </ActionButton>
  );

  if (tooltip && typeof tooltip === 'object') {
    return (
      <Tooltip {...tooltip}>
        <Box width="100%">{actionButton}</Box>
      </Tooltip>
    );
  }
  return actionButton;
};

SingleAction.propTypes = {
  action: PropTypes.instanceOf(Object),
};

const ListActions = (props) => {
  const { t } = useTransl();

  const { actions: rawActionsList, title, color, isFullWidth } = props;

  const actions =
    rawActionsList?.length &&
    rawActionsList.filter((action) => action.show !== false);

  if (!actions?.length) {
    return null;
  }

  const items = formatActionItems(actions, isFullWidth);
  if (items.length === 1) {
    return <SingleAction action={items[0]} />;
  }

  const menuTitle = title ?? t('title.actions');

  return (
    <Box sx={{ width: isFullWidth ? '100%' : 'auto' }}>
      <DropDownMenu
        title={menuTitle}
        color={color}
        items={items}
        isFullWidth={isFullWidth}
        isButton
      />
    </Box>
  );
};

ListActions.propTypes = {
  actions: PropTypes.instanceOf(Array).isRequired,
  title: PropTypes.string,
  color: PropTypes.string,
  isFullWidth: PropTypes.bool,
};

export default ListActions;
